import { SET_CONFIG, SET_ERROR, SET_LOADING, SET_USERS, TimedoctorState } from './timedoctorTypes';
import { Action } from '../../utils/commonTypes';

const initialState: TimedoctorState = {
  config: null,
  users: [],
  loading: false,
  error: null,
};

const timedoctorReducer = (state: TimedoctorState = initialState, action: Action): TimedoctorState => {
  switch (action.type) {
    case SET_CONFIG:
      return { ...state, config: action.payload };

    case SET_USERS:
      return { ...state, users: action.payload };

    case SET_LOADING:
      return { ...state, loading: action.payload };

    case SET_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default timedoctorReducer;
